import { Component, effect, Inject, input, output, Renderer2 } from '@angular/core';
import { IconDefinition, faXmark } from '@fortawesome/free-solid-svg-icons';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-modal',
  imports: [
    FaIconComponent
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {
  readonly title = input.required<string>();
  readonly isOpen = input.required<boolean>();
  readonly styleClass = input<string>('h-fit w-[750px]');
  readonly closed = output<void>();

  readonly closeIcon: IconDefinition = faXmark;

  constructor(
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    effect(() => {
      if (this.isOpen()) {
        this.renderer.addClass(this.document.body, 'overflow-hidden');
      } else {
        this.renderer.removeClass(this.document.body, 'overflow-hidden');
      }
    });
  }

  onCloseModal(): void {
    this.closed.emit();
  }
}
